module.exports = __webpack_public_path__ + "static/favicon-a9492937227a548a97a2f30df89a6f33.ico";